import { IndicatorsCatalog } from "@/features/indicators/components/IndicatorsCatalog";

export function IndicatorsPage() {
  return <IndicatorsCatalog />;
}
